<template>
  <AdminLayout><ImagesTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import ImagesTable from './ImagesTable.vue';

export default {
  name: 'AdminImages',
  components: { AdminLayout, ImagesTable },
};
</script>
